import { render } from "./Masjed alfattah alaleem Hall.vue?vue&type=template&id=fe6a2dfc&scoped=true"
const script = {}

import "./Masjed alfattah alaleem Hall.vue?vue&type=style&index=0&id=fe6a2dfc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fe6a2dfc"

export default script